import { User } from "oidc-client";

import { ITenant, IUserRoleAccess } from "ui/shared/models/common";

export enum UserStateErrors {
  SignInFailed,
  AuthorizationFailed,
  InvalidSession
}

export interface IIdentity {
  id: string;
  tenantId: string;
  profile: {
    name?: string;
    firstName?: string;
    lastName?: string;
    email?: string;
  };
}

export type PlexUser = {
  profile: {
    tenantId: string;
  };
} & User;

export interface IAuthorizationData {
  roles: string[];
  tenants?: string[];
  enterprises?: string[];
}

export interface IRole {
  tenant: string;
  role: string;
  enterprise: string;
}

export interface IUserState {
  identity?: IIdentity;
  authenticationProcessing: boolean;
  isAuthenticated: boolean;
  authorizationProcessing: boolean;
  signOutProcessing?: boolean;
  isAuthorized?: boolean;
  roles: IRole[];
  tenants: ITenant[];
  remoteAuthenticationRequired?: boolean;
  error?: UserStateErrors;
  userRoleAccessData?: IUserRoleAccess;
}

export const getInitialUserState = (): IUserState => {
  return {
    identity: undefined,
    authenticationProcessing: false,
    isAuthenticated: false,
    authorizationProcessing: false,
    isAuthorized: false,
    roles: [],
    tenants: [],
    error: undefined
  };
};

export type SelectorState = { user: IUserState };

const getStateSelectorsProvider = () => ({
  getRoles: (state: SelectorState) => state.user.roles,
  getTenantId: (state: SelectorState) => state.user.identity?.tenantId
});

export const selectors = getStateSelectorsProvider();
